var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63184 15.787H14.5415C15.5815 15.787 16.1895 15.1937 16.1895 14.1683V7.12976L17.2075 7.98669C17.354 8.11121 17.5225 8.22107 17.7275 8.22107C18.0718 8.22107 18.3501 8.00867 18.3501 7.6571C18.3501 7.43738 18.2769 7.29089 18.123 7.15906L16.1895 5.53308V2.50085C16.1895 2.17859 15.9844 1.97351 15.6621 1.97351H14.8784C14.5635 1.97351 14.3511 2.17859 14.3511 2.50085V3.98767L10.4985 0.750366C9.95654 0.28894 9.28271 0.28894 8.7334 0.750366L1.10156 7.15906C0.94043 7.29089 0.867188 7.46667 0.867188 7.63513C0.867188 7.93542 1.10156 8.22107 1.49707 8.22107C1.70215 8.22107 1.87061 8.11121 2.02441 7.98669L2.97656 7.18103V14.1683C2.97656 15.1937 3.58447 15.787 4.63184 15.787ZM11.7217 9.70056C11.7217 9.36365 11.502 9.14392 11.165 9.14392H8.05957C7.71533 9.14392 7.49561 9.36365 7.49561 9.70056V14.6078H4.88086C4.41211 14.6078 4.15576 14.3441 4.15576 13.868V6.19226L9.35596 1.83435C9.51709 1.68787 9.71484 1.68787 9.87598 1.83435L15.0103 6.14099V13.868C15.0103 14.3441 14.7539 14.6078 14.2925 14.6078H11.7217V9.70056Z",
    fill: "#8592C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1cca6c6f062d8b3ed5dcf4c780fc0e0d.svg";
export { ForwardRef as ReactComponent };